import type { MessageRenderer, RendererConfig, RendererResult, AnimationState } from './types';

/**
 * Renderer that displays content immediately without animation
 */
export class NoneRenderer implements MessageRenderer {
  render(
    _messageId: string,
    config: RendererConfig,
    _currentState: AnimationState
  ): RendererResult {
    return {
      displayContent: config.content,
      isComplete: true,
    };
  }

  getInitialState(): AnimationState {
    return {};
  }
}

